<div class="col-12 flex flex-wrap">
  <div class="w-full flex justify-content-end">
      <p-fileUpload
                    chooseLabel="Scegli file"
                    name="demo[]"
                    [showUploadButton]="false"
                    class="w-full" styleClass="w-full"
                    [cancelLabel]="'Rimuovi'"
                    accept=".pdf"
                    [multiple]="false"
                    [maxFileSize]="100000"
                    (onSelect)="onUpload($event)"
      ></p-fileUpload>
  </div>
  <div class="w-full flex mt-5">
    <label class="labelWidth">Tipologia documento *</label>
    <select class="w-full" pInputText style="appearance: auto"
        [(ngModel)]="selectedTypeDocument" (change)="changeDocumentType(selectedTypeDocument)">
      <option *ngFor="let item of lstFileTypes; let i = index" [ngValue]="item">{{item.Tipo}}</option>
      <option [ngValue]="null"></option>
    </select>
  </div>
  <div class="col-12 p-0" *ngIf="selectedTypeDocument.DateIsRequired">
    <div class="col-12 flex p-0 mt-2">
      <label class="labelWidth">Data Dal</label>
      <p-calendar [showIcon]="true"
                  inputId="icon"
                  styleClass="w-full"
                  appendTo="body"
                  class="w-full"
                  name="birthDate"
                  [(ngModel)]="saveDocumentRequest.DataDal"
                  dateFormat="{{displayDateFormat}}"
                  yearRange="{{yearRange}}"
                  [firstDayOfWeek]="1"
                  [required]="true"></p-calendar>
      </div>
    <div class="col-12 flex p-0 mt-2">
      <label class="labelWidth">Data Al</label>
      <p-calendar [showIcon]="true"
                  inputId="icon"
                  styleClass="w-full"
                  appendTo="body"
                  class="w-full"
                  name="birthDate"
                  [(ngModel)]="saveDocumentRequest.DataAl"
                  dateFormat="{{displayDateFormat}}"
                  yearRange="{{yearRange}}"
                  [firstDayOfWeek]="1"
                  [required]="true"></p-calendar>
    </div>
  </div>
  <div class="col-12 p-0" *ngFor="let voce of selectedTypeDocument.ExtraInfoList; index as i">
    <div class="col-12 flex p-0 mt-2">
      <label class="labelWidth">{{voce.ExtraInfoLabel}} <label *ngIf="voce.IsRequired">*</label> </label>
      <input type="text" class="w-full"
             pInputText
             *ngIf="voce.ExtraInfoType == 'text'"
             [(ngModel)]="voce.ExtraInfoValueText">

      <input type="text" class="w-full"
             pInputText
             [(ngModel)]="voce.ExtraInfoValueTextOnlyLetters"
             *ngIf="voce.ExtraInfoType == 'text-only-letters'">

      <select class="w-full" pInputText style="appearance: auto"
              *ngIf="voce.ExtraInfoType == 'select'"
              [(ngModel)]="voce.ExtraInfoValueSelect">
        <option *ngFor="let item of voce.ExtraInfoDetailList; let i = index" [ngValue]="item.InfoKey">{{item.InfoValue}}</option>
        <option [ngValue]="null"></option>
      </select>

      <p-calendar [showIcon]="true"
                  inputId="icon"
                  styleClass="w-full"
                  appendTo="body"
                  class="w-full"
                  name="birthDate"
                  *ngIf="voce.ExtraInfoType == 'date'"
                  [(ngModel)]="voce.ExtraInfoValueDate"
                  dateFormat="{{displayDateFormat}}"
                  yearRange="{{yearRange}}"
                  [firstDayOfWeek]="1"
                  [required]="true"></p-calendar>

      <p-checkbox id="privacyCheck"
                  [binary]="true"
                  name="privacyCheck"
                  class="w-full"
                  styleClass="w-full"
                  *ngIf="voce.ExtraInfoType == 'checkbox'"
                  [required]="true"
                  [(ngModel)]="voce.ExtraInfoValueCheckBox"></p-checkbox>
    </div>

  </div>
  <div class="col-12 flex justify-content-end p-0 mt-2">
    <div class="col-4 fle justify-content-end">
      <button pButton pRipple label="Salva" icon="pi pi-file" class="w-full p-button-rounded" (click)="saveDocument()"></button>
    </div>
  </div>
</div>
